var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mobility"},[_c('mobility-hero'),_vm._v(" "),_c('mobility-slider'),_vm._v(" "),_c('mobility-offers'),_vm._v(" "),_c('mobility-rent'),_vm._v(" "),_c('mobility-alt-image-text'),_vm._v(" "),_c('mobility-testimonials'),_vm._v(" "),_c('button-back-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }